<template>
	<div>
		<div class="profile-main-container">
			<div class="d-flex align-items-center justify-content-center">
				<div class="profile-heading d-flex align-items-center mt-3 width-95">
					<!-- <img
						class="mr-2 pointer"
						src="../assets/blue-bckarrow.svg"
						alt=""
						@click="$router.go(-1)"
					/> -->
					<div class="">
						<span>Account Settings</span>
					</div>
				</div>
			</div>

			<!-- tabs design  -->
			<div class="w-100 d-flex justify-content-center">
				<b-tabs class="profile-tabs" v-model="tabIndex">
					<!-- First level tabs -->
					<b-tab
						@click="navigate('personalData')"
						:active="activeTab == 'personalData'"
					>
						<template #title>
							<div class="d-flex align-items-center justify-content-center">
								Personal Data
							</div>
							<div
								v-if="activeTab == 'personalData'"
								class="profile-tbs-sel"
							></div>
						</template>
					</b-tab>
					<!-- second level tabs-->
					<b-tab
						@click="navigate('basisAuthentication')"
						:active="activeTab == 'basisAuthentication'"
					>
						<template #title>
							<div class="d-flex align-items-center justify-content-center">
								Basic Authentication
							</div>
							<div
								v-if="activeTab == 'basisAuthentication'"
								class="profile-tbs-sel"
							></div>
						</template>
					</b-tab>
					<!-- third level tabs-->
					<b-tab
						v-if="notGoogleLogin"
						@click="navigate('deviceActivity')"
						:active="activeTab == 'deviceActivity'"
					>
						<template #title>
							<div class="d-flex align-items-center justify-content-center">
								Device Activity
							</div>
							<div
								v-if="activeTab == 'deviceActivity'"
								class="profile-tbs-sel"
							></div>
						</template>
					</b-tab>
					<!-- fourth level tabs-->
					<b-tab
						@click="navigate('visibility')"
						:active="activeTab == 'visibility'"
					>
						<template #title>
							<div class="d-flex align-items-center justify-content-center">
								Visibility
							</div>
							<div
								v-if="activeTab == 'visibility'"
								class="profile-tbs-sel"
							></div>
						</template>
					</b-tab>
					<!-- fifth level tabs-->
					<!-- <b-tab
						@click="navigate('InvoiceDownload')"
						:active="activeTab == 'InvoiceDownload'"
					>
						<template #title>
							<div class="d-flex align-items-center justify-content-center">
								Invoice
							</div>
							<div
								v-if="activeTab == 'InvoiceDownload'"
								class="profile-tbs-sel"
							></div>
						</template>
					</b-tab> -->
					<!-- sixth level tabs-->
					<b-tab
						@click="navigate('deleteAccount')"
						:active="activeTab == 'deleteAccount'"
					>
						<template #title>
							<div class="d-flex align-items-center justify-content-center">
								Delete Account
							</div>
							<div
								v-if="activeTab == 'deleteAccount'"
								class="profile-tbs-sel"
							></div>
						</template>
					</b-tab>
					<b-tab @click="navigate('query')" :active="activeTab == 'raiseQuery'">
						<template #title>
							<div class="d-flex align-items-center justify-content-center">
								Raise A Query
							</div>
							<div
								v-if="activeTab == 'raiseQuery'"
								class="profile-tbs-sel"
							></div>
						</template>
					</b-tab>
				</b-tabs>
			</div>
			<div
				class="w-100 d-flex align-items-center justify-content-center flex-column p-2 profile-height-adjustment inputPlaceholder"
			>
				<div
					class="profile-sub-containers-height mt-2 pr-2"
					@scroll="handleScroll"
				>
					<div class="profile-sub-containers" id="personalData">
						<div v-if="showPersonalDataShimmer">
							<b-skeleton class="h-25 w-25"></b-skeleton>
						</div>

						<div v-else class="profile-containers-head">Personal Data</div>
						<div>
							<b-row v-if="showPersonalDataShimmer">
								<b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
							</b-row>
							<b-row v-else>
								<b-col>
									<div class="d-flex align-items-center w-100 mt-4">
										<div class="width-30 topDiv">
											<label class="candash-modal-label"
												>First Name<span class="asterik">&nbsp;*</span></label
											>
										</div>
										<div class="width-70">
											<b-form-input
												:class="
													editProfile == false || profileLoader == true
														? 'disabled-profile-inputField'
														: $v.profileDetails.firstName.$error
														? 'error-inputField'
														: ''
												"
												class="profile-inputField"
												placeholder="Enter First Name"
												type="text"
												v-model="profileDetails.firstName"
												:disabled="
													editProfile == false || profileLoader == true
												"
												@keypress="alphabetsOnly"
												spellCheck="false"
											>
											</b-form-input>
										</div>
									</div>
									<div
										v-if="
											$v.profileDetails.firstName.$dirty &&
											!$v.profileDetails.firstName.required
										"
										class="validation-font mt-1"
									>
										Required
									</div>
									<div
										v-if="
											$v.profileDetails.firstName.$dirty &&
											!$v.profileDetails.firstName.maxLength
										"
										class="validation-font mt-1"
									>
										Exceeded the max char length of 38
									</div>
									<div
										v-if="
											editProfile &&
											$v.profileDetails.firstName.$dirty &&
											!$v.profileDetails.firstName.alphaNumeric
										"
										class="validation-font mt-1"
									>
										Invalid Name
									</div>
								</b-col>
								<b-col>
									<div class="d-flex align-items-center w-100 mt-4">
										<div class="width-30 topDiv">
											<label class="candash-modal-label"
												>Last Name<span class="asterik">&nbsp;*</span></label
											>
										</div>
										<div class="width-70">
											<b-form-input
												:class="
													editProfile == false || profileLoader == true
														? 'disabled-profile-inputField'
														: editProfile && $v.profileDetails.lastName.$error
														? 'error-inputField'
														: ''
												"
												class="profile-inputField"
												placeholder="Enter Last Name"
												type="text"
												v-model="profileDetails.lastName"
												:disabled="
													editProfile == false || profileLoader == true
												"
												@keypress="alphabetsOnly"
												spellCheck="false"
											>
											</b-form-input>
										</div>
									</div>
									<div
										v-if="
											$v.profileDetails.lastName.$dirty &&
											!$v.profileDetails.lastName.required
										"
										class="validation-font mt-1"
									>
										Required
									</div>
									<div
										v-if="
											$v.profileDetails.lastName.$dirty &&
											!$v.profileDetails.lastName.maxLength
										"
										class="validation-font mt-1"
									>
										Exceeded the max char length of 38
									</div>
									<div
										v-if="
											editProfile &&
											$v.profileDetails.lastName.$dirty &&
											!$v.profileDetails.lastName.alphaNumeric
										"
										class="validation-font mt-1"
									>
										Invalid Name
									</div>
								</b-col>
							</b-row>
							<b-row v-if="showPersonalDataShimmer">
								<b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
							</b-row>

							<b-row v-else-if="!showPersonalDataShimmer">
								<b-col cols="6">
									<div class="d-flex align-items-center w-100 mt-4">
										<div class="width-30 topDiv">
											<label class="candash-modal-label">Phone Number</label>
										</div>
										<div class="width-70">
											<!--  -->
											<b-form-input
												placeholder="Enter Phone Number"
												class="profile-inputField disabled-profile-inputField"
												disabled
												type="text"
												maxlength="10"
												v-model="profileDetails.phoneNumber"
												@keypress="numbersOnly"
												spellCheck="false"
											>
											</b-form-input>
											<!-- <div
												v-if="
													$v.profileDetails.phoneNumber.$dirty &&
													!$v.profileDetails.phoneNumber.required
												"
												class="validation-font mt-1"
											>
												Required
											</div>
											<div
												v-if="
													($v.profileDetails.phoneNumber.$dirty &&
														!$v.profileDetails.phoneNumber.numeric) ||
													(!$v.profileDetails.phoneNumber.alpha &&
														$v.profileDetails.phoneNumber.required)
												"
												class="validation-font mt-1"
											>
												Invalid Phone Number
											</div> -->
										</div>
									</div>
								</b-col>
								<b-col cols="6">
									<div class="d-flex align-items-center w-100 mt-4">
										<div class="width-30 topDiv">
											<label class="candash-modal-label">Email</label>
										</div>
										<div class="width-70">
											<b-form-input
												class="email-profile-inputField"
												placeholder="Enter E-mail ID"
												type="text"
												v-model="profileDetails.email"
												disabled
												spellCheck="false"
											>
											</b-form-input>
										</div>
									</div>
								</b-col>
							</b-row>
						</div>

						<div
							class="mt-4 d-flex align-items-center justify-content-end"
							v-if="editProfile == true"
						>
							<div class="d-flex align-items-center">
								<div class="d-flex align-items-center">
									<b-button
										:disabled="profileLoader == true"
										class="candash-cancelBtn pointer mr-4"
										@click="(editProfile = false), reassignDetails()"
									>
										Cancel
									</b-button>

									<div class="position-relative">
										<b-button
											:class="
												profileLoader
													? 'candash-addBtn loader-class defaultCursor'
													: 'candash-addBtn pointer'
											"
											@click="saveProfileDetails()"
										>
											<span v-if="!profileLoader">Save</span>
										</b-button>
										<div v-if="profileLoader" class="loader-pos-new">
											<Loader />
										</div>
									</div>
								</div>
							</div>
						</div>

						<div
							v-else-if="
								editProfile == false && showPersonalDataShimmer == false
							"
							class="mt-4 d-flex align-items-center justify-content-end"
						>
							<b-button
								class="candash-fixwidBtn ml-3 pointer"
								@click="editPersonalData()"
							>
								Edit
							</b-button>
						</div>
					</div>

					<div class="profile-sub-containers mt-2" id="basicAuth">
						<div v-if="showBasicAuthShimmer">
							<b-skeleton class="w-25 h-25"></b-skeleton>
						</div>
						<div
							class="d-flex align-items-center justify-content-between"
							v-else-if="!showBasicAuthShimmer"
						>
							<div class="profile-containers-head">
								{{ hasPassword ? "Basic Authentication" : "Set Password" }}
							</div>
							<div class="d-flex align-items-center created-on-font">
								<!-- <div>Created on : &nbsp;</div>
                <div>{{ createdAt }}</div> -->
							</div>
						</div>
						<div v-if="showBasicAuthShimmer">
							<b-skeleton class="mt-4 w-85 h-25"></b-skeleton>
						</div>

						<div
							v-else-if="savedAuthentication && !showBasicAuthShimmer"
							class="d-flex align-items-center justify-content-between"
						>
							<div class="d-flex align-items-center mt-4 width-48">
								<div class="width-30">
									<label class="candash-modal-label width-150px"
										>Password<span class="asterik">&nbsp;*</span></label
									>
								</div>
								<div class="position-relative width-70">
									<b-form-input
										class="disabled-profile-inputField"
										placeholder="************"
										disabled
										type="text"
									>
									</b-form-input>
								</div>
							</div>
							<div class="mt-5">
								<b-button
									@click="
										(savedAuthentication = false),
											(showCurrentPassword = false),
											(showNewPassword = false),
											(passwordDetails.newPswd = ''),
											(hasUppercase = false),
											(hasLowercase = false),
											(hasSplcharacter = false),
											(hasNumber = false),
											(matchCriteria = false);
										$v.passwordDetails.$reset();
									"
									class="candash-fixwidBtn ml-3 pointer"
								>
									Reset
								</b-button>
							</div>
						</div>

						<div v-else>
							<div
								v-if="hasPassword"
								class="d-flex align-items-center mt-4 w-50 position-relative"
							>
								<div class="width-30">
									<label class="candash-modal-label width-150px"
										>Current Password<span class="asterik">&nbsp;*</span></label
									>
								</div>
								<div class="ml-3 position-relative width-70">
									<b-form-input
										:class="
											$v.passwordDetails.currentPassword.$error ||
											checkCurrentPsw == true
												? 'error-inputField'
												: ''
										"
										class="profile-inputField"
										placeholder="Enter Current Password"
										:type="showCurrentPassword ? 'text' : 'password'"
										v-model="$v.passwordDetails.currentPassword.$model"
										:autocomplete="showCurrentPassword ? 'off' : 'new-password'"
										v-no-copy-paste
									>
									</b-form-input>
									<div
										class="psw-set-noView-icon"
										@click="togglePasswordVisibility('showCurrentPassword')"
										v-if="showCurrentPassword"
									>
										<img
											class="pointer"
											src="../assets/New Profile/view-icon.svg"
											alt=""
										/>
									</div>
									<div
										class="psw-set-noView-icon"
										@click="togglePasswordVisibility('showCurrentPassword')"
										v-else
									>
										<img
											class="pointer"
											src="../assets/New Profile/not-view-icon.svg"
											alt=""
										/>
									</div>
									<div
										v-if="
											$v.passwordDetails.currentPassword.$dirty &&
											!$v.passwordDetails.currentPassword.required
										"
										class="basicAuth-validation-font"
									>
										Required
									</div>
									<div
										v-else-if="
											$v.passwordDetails.currentPassword.$dirty &&
											!$v.passwordDetails.currentPassword.maxLength
										"
										class="basicAuth-validation-font"
									>
										Exceeded the max char length of 55
									</div>
									<div
										v-if="
											passwordDetails.currentPassword != '' &&
											checkCurrentPsw == true
										"
										class="basicAuth-validation-font"
									>
										Current password is wrong
									</div>
								</div>
							</div>

							<div
								class="d-flex align-items-center mt-4 w-50 position-relative"
							>
								<div class="width-30">
									<label class="candash-modal-label width-150px"
										>New Password<span class="asterik">&nbsp;*</span></label
									>
								</div>
								<div class="ml-3 position-relative width-70">
									<b-form-input
										:class="{
											'error-inputField':
												$v.passwordDetails.newPswd.$error ||
												(checkNewPsw == false && passwordDetails.newPswd != ''),
											'pr-55':
												checkNewPsw == true &&
												passwordDetails.newPswd != '' &&
												hasUppercase &&
												hasLowercase &&
												hasNumber &&
												hasSplcharacter,
										}"
										class="profile-inputField"
										placeholder="Enter New Password"
										v-model="$v.passwordDetails.newPswd.$model"
										@input="validatePassword"
										:type="showNewPassword ? 'text' : 'password'"
										:autocomplete="showNewPassword ? 'off' : 'new-password'"
										v-no-copy-paste
									>
									</b-form-input>
									<div
										v-if="showNewPassword"
										class="psw-set-noView-icon"
										@click="togglePasswordVisibility('showNewPassword')"
									>
										<img
											class="pointer"
											src="../assets/New Profile/view-icon.svg"
											alt=""
										/>
									</div>
									<div
										v-else
										class="psw-set-noView-icon"
										@click="togglePasswordVisibility('showNewPassword')"
									>
										<img
											class="pointer"
											src="../assets/New Profile/not-view-icon.svg"
											alt=""
										/>
									</div>
									<div
										class="psw-set-noView-icon-2"
										v-if="
											checkNewPsw == true &&
											passwordDetails.newPswd != '' &&
											hasUppercase &&
											hasLowercase &&
											hasNumber &&
											hasSplcharacter
										"
									>
										<img src="../assets/New Profile/match.svg" alt="" />
									</div>
									<div
										v-else-if="
											passwordDetails.newPswd != '' && checkNewPsw == false
										"
										class="psw-set-noView-icon-2"
									>
										<img src="../assets/New Profile/no-match.svg" alt="" />
									</div>
								</div>
								<div
									v-if="passwordDetails.newPswd != '' && checkNewPsw == false"
									class="adjust-uppercase newPass-validation-font ml-2"
								>
									New Password cannot be same as current password
								</div>

								<div
									v-else-if="
										$v.passwordDetails.newPswd.$dirty &&
										!$v.passwordDetails.newPswd.maxLength
									"
									class="adjust-uppercase newPass-validation-font ml-2"
								>
									Exceeded the max char length of 55
								</div>
								<div
									v-else
									class="d-flex align-items-center adjust-uppercase w-100"
								>
									<!-- first div should not have ml-2-->
									<div>
										<div class="d-flex align-items-center" v-if="hasUppercase">
											<div>
												<img
													src="../assets/New Profile/select-uppercase.svg"
													alt=""
												/>
												<!-- <img src="../assets/New Profile/reject-uppercase.svg" alt="" /> -->
											</div>
											<div class="select-uppercase-font ml-2 mt-1">
												<!-- for reject uppercase font ---- reject-uppercase-font -->
												1 Upper case
											</div>
										</div>
										<div class="d-flex align-items-center" v-else>
											<div>
												<img
													src="../assets/New Profile/reject-uppercase.svg"
													alt=""
												/>
											</div>
											<div class="reject-uppercase-font ml-2 mt-1">
												1 Upper case
											</div>
										</div>
									</div>

									<!-- second -->
									<div>
										<div
											class="d-flex align-items-center ml-2"
											v-if="hasLowercase && passwordDetails.newPswd != ''"
										>
											<div>
												<img
													src="../assets/New Profile/select-uppercase.svg"
													alt=""
												/>
												<!-- <img src="../assets/New Profile/reject-uppercase.svg" alt="" /> -->
											</div>
											<div class="select-uppercase-font ml-2 mt-1">
												<!-- for reject uppercase font ---- reject-uppercase-font -->
												3 Lower case
											</div>
										</div>
										<div class="d-flex align-items-center ml-2" v-else>
											<div>
												<img
													src="../assets/New Profile/reject-uppercase.svg"
													alt=""
												/>
											</div>
											<div class="reject-uppercase-font ml-2 mt-1">
												3 Lower case
											</div>
										</div>
									</div>

									<!-- third -->
									<div>
										<div
											class="d-flex align-items-center ml-2"
											v-if="hasSplcharacter"
										>
											<div>
												<img
													src="../assets/New Profile/select-uppercase.svg"
													alt=""
												/>
												<!-- <img src="../assets/New Profile/reject-uppercase.svg" alt="" /> -->
											</div>
											<div class="select-uppercase-font ml-2 mt-1">
												<!-- for reject uppercase font ---- reject-uppercase-font -->
												1 Special character
											</div>
										</div>
										<div class="ml-2 d-flex align-items-center" v-else>
											<div>
												<img
													src="../assets/New Profile/reject-uppercase.svg"
													alt=""
												/>
											</div>
											<div class="reject-uppercase-font ml-2 mt-1">
												1 Special character
											</div>
										</div>
									</div>

									<!-- fourth -->
									<div>
										<div
											class="d-flex align-items-center ml-2"
											v-if="hasNumber"
										>
											<div>
												<img
													src="../assets/New Profile/select-uppercase.svg"
													alt=""
												/>
												<!-- <img src="../assets/New Profile/reject-uppercase.svg" alt="" /> -->
											</div>
											<div class="select-uppercase-font ml-2 mt-1">
												<!-- for reject uppercase font ---- reject-uppercase-font -->
												1 Number
											</div>
										</div>
										<div class="ml-2 d-flex align-items-center" v-else>
											<div>
												<img
													src="../assets/New Profile/reject-uppercase.svg"
													alt=""
												/>
											</div>
											<div class="reject-uppercase-font ml-2 mt-1">
												1 Number
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="d-flex align-items-center w-50 margin-top-class">
								<div class="width-30">
									<label class="candash-modal-label width-150px"
										>Confirm Password<span class="asterik">&nbsp;*</span></label
									>
								</div>

								<div class="ml-3 position-relative width-70">
									<b-form-input
										:class="
											$v.passwordDetails.confirmPswd.$error ||
											(passwordDetails.confirmPswd != '' &&
												!passwordsMatch &&
												passwordDetails.newPswd != '')
												? 'error-inputField'
												: ''
										"
										class="profile-inputField"
										placeholder="Enter Confirm Password"
										v-model="$v.passwordDetails.confirmPswd.$model"
										type="password"
										:autocomplete="showConfirmPassword ? 'off' : 'new-password'"
										v-no-copy-paste
									>
									</b-form-input>
									<div
										class="psw-set-noView-icon"
										v-if="
											passwordsMatch &&
											passwordDetails.confirmPswd != '' &&
											passwordDetails.newPswd != '' &&
											hasUppercase &&
											hasLowercase &&
											hasNumber &&
											hasSplcharacter
										"
									>
										<img src="../assets/New Profile/match.svg" alt="" />
									</div>
									<div
										class="psw-set-noView-icon"
										v-else-if="
											!passwordsMatch &&
											passwordDetails.confirmPswd != '' &&
											passwordDetails.newPswd != ''
										"
									>
										<img src="../assets/New Profile/no-match.svg" alt="" />
									</div>
									<div
										v-if="
											$v.passwordDetails.confirmPswd.$dirty &&
											!$v.passwordDetails.confirmPswd.required
										"
										class="basicAuth-validation-font"
									>
										Required
									</div>
									<div
										v-else-if="
											$v.passwordDetails.confirmPswd.$dirty &&
											!$v.passwordDetails.confirmPswd.maxLength
										"
										class="basicAuth-validation-font"
									>
										Exceeded the max char length of 55
									</div>
									<div
										v-else-if="
											!passwordsMatch &&
											passwordDetails.confirmPswd != '' &&
											passwordDetails.newPswd != ''
										"
										class="basicAuth-validation-font"
									>
										Password doesn't match
									</div>
								</div>
							</div>
						</div>

						<div
							class="mt-4 d-flex align-items-center justify-content-end"
							v-if="!savedAuthentication"
						>
							<div class="d-flex align-items-center">
								<div class="d-flex align-items-center">
									<b-button
										class="candash-cancelBtn pointer mr-4"
										@click="(savedAuthentication = true), cancelResetPswd()"
									>
										Cancel
									</b-button>

									<div class="position-relative">
										<b-button
											:class="
												Loader
													? 'candash-addBtn loader-class'
													: 'candash-addBtn pointer'
											"
											@click="resetPwd()"
										>
											<span v-if="!Loader">Save</span>
										</b-button>
										<div v-if="Loader" class="loader-pos-new">
											<Loader />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div
						v-if="notGoogleLogin"
						class="profile-sub-containers mt-2"
						id="deviceActivity"
					>
						<div v-if="showDeviceActivityShimmer">
							<b-skeleton class="h-25 w-25"></b-skeleton>
						</div>

						<div
							v-else-if="!showDeviceActivityShimmer"
							class="profile-containers-head"
						>
							Device Activity
						</div>
						<div class="mt-2" v-if="showDeviceActivityShimmer">
							<div v-for="(i, index) in loopvar" :key="index">
								<div class="pro-padding">
									<div class="d-flex align-items-center">
										<div class="width-7">
											<b-skeleton type="avatar"></b-skeleton>
										</div>
										<div class="width-93">
											<b-row>
												<b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
											</b-row>
											<b-row>
												<b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
											</b-row>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="mt-2" v-else-if="!showDeviceActivityShimmer">
							<div v-if="Object.keys(currentlyTrue).length != 0">
								<div
									class="currentlyActive-tag mt-2"
									v-if="currentlyTrue.current"
								>
									Currently Active
								</div>

								<div class="d-flex align-items-center">
									<div class="width-7">
										<img
											v-if="
												currentlyTrue.browser.slice(
													0,
													currentlyTrue.browser.indexOf('/')
												) == 'Mobile Safari'
											"
											src="../assets/icons/deviceActivity/Safari.svg"
											alt=""
										/>
										<img
											v-else-if="
												currentlyTrue.browser.slice(
													0,
													currentlyTrue.browser.indexOf('/')
												) == 'Chrome' ||
												currentlyTrue.browser.slice(
													0,
													currentlyTrue.browser.indexOf('/')
												) == 'Chrome Mobile' ||
												currentlyTrue.browser.slice(
													0,
													currentlyTrue.browser.indexOf('/')
												) == 'Chrome Mobile iOS' ||
												currentlyTrue.browser.slice(
													0,
													currentlyTrue.browser.indexOf('/')
												) == 'Edge'
											"
											src="../assets/icons/deviceActivity/google.svg"
											alt=""
										/>
										<img
											v-else-if="
												currentlyTrue.browser.slice(
													0,
													currentlyTrue.browser.indexOf('/')
												) == 'Firefox'
											"
											src="../assets/icons/deviceActivity/firefox.svg"
											alt=""
										/>
										<img
											v-else-if="
												currentlyTrue.browser.slice(
													0,
													currentlyTrue.browser.indexOf('/')
												) == 'Safari'
											"
											src="../assets/icons/deviceActivity/Safari.svg"
											alt=""
										/>
										<img
											v-else-if="
												currentlyTrue.browser.slice(
													0,
													currentlyTrue.browser.indexOf('/')
												) == 'Opera'
											"
											src="../assets/icons/deviceActivity/Opera.svg"
											alt=""
										/>
										<img
											v-else
											src="../assets/icons/deviceActivity/default.svg"
											alt=""
										/>
									</div>
									<div class="width-93">
										<div
											class="d-flex align-items-center justify-content-between"
										>
											<div class="device-activity-head mt-2">
												{{ currentlyTrue.browser }}
											</div>
											<div
												class="sign-out pointer"
												@click="signOutConfirm(currentlyTrue)"
											>
												Log Out
											</div>
										</div>
										<div class="mt-2 w-100 d-flex">
											<div class="width-40">
												<div class="started-at">Started at</div>
												<div class="device-activity-head">
													{{ currentlyTrue.started }}
												</div>
											</div>

											<div class="width-40">
												<div class="started-at">Expires at</div>
												<div class="device-activity-head">
													{{ currentlyTrue.expires }}
												</div>
											</div>

											<div class="width-20">
												<div class="started-at">Last accessed on</div>
												<div class="device-activity-head">
													{{ currentlyTrue.lastAccess }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div v-if="deviceCheck.length > 1" class="visibility-line"></div>
							<div
								class="profile-containers-head mt-3"
								v-if="deviceCheck.length > 1"
							>
								Other Devices
							</div>

							<div v-for="(i, index) in device" :key="index">
								<div
									class="pro-padding"
									v-for="(j, index2) in i.sessions"
									:key="index2"
									:class="i.sessions.length > 1 ? 'mt-3' : ''"
								>
									<div
										class="d-flex align-items-center"
										v-if="!j.current && !showDeviceActivityShimmer"
									>
										<div class="width-7">
											<img
												v-if="
													j.browser.slice(0, j.browser.indexOf('/')) ==
													'Mobile Safari'
												"
												src="../assets/icons/deviceActivity/Safari.svg"
												alt=""
											/>
											<img
												v-else-if="
													j.browser.slice(0, j.browser.indexOf('/')) ==
														'Chrome' ||
													j.browser.slice(0, j.browser.indexOf('/')) ==
														'Chrome Mobile' ||
													j.browser.slice(0, j.browser.indexOf('/')) ==
														'Chrome Mobile iOS' ||
													j.browser.slice(0, j.browser.indexOf('/')) == 'Edge'
												"
												src="../assets/icons/deviceActivity/google.svg"
												alt=""
											/>
											<img
												v-else-if="
													j.browser.slice(0, j.browser.indexOf('/')) ==
													'Firefox'
												"
												src="../assets/icons/deviceActivity/firefox.svg"
												alt=""
											/>
											<img
												v-else-if="
													j.browser.slice(0, j.browser.indexOf('/')) == 'Safari'
												"
												src="../assets/icons/deviceActivity/Safari.svg"
												alt=""
											/>
											<img
												v-else-if="
													j.browser.slice(0, j.browser.indexOf('/')) == 'Opera'
												"
												src="../assets/icons/deviceActivity/Opera.svg"
												alt=""
											/>
											<img
												v-else
												src="../assets/icons/deviceActivity/default.svg"
												alt=""
											/>
										</div>
										<div class="width-93">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div class="device-activity-head mt-2">
													{{ j.browser }}
												</div>
												<div
													class="sign-out pointer"
													@click="signOutConfirm(j)"
												>
													Log Out
												</div>
											</div>
											<div class="mt-2 w-100 d-flex">
												<div class="width-40">
													<div class="started-at">Started at</div>
													<div class="device-activity-head">
														{{ j.started }}
													</div>
												</div>

												<div class="width-40">
													<div class="started-at">Expires at</div>
													<div class="device-activity-head">
														{{ j.expires }}
													</div>
												</div>

												<div class="width-20">
													<div class="started-at">Last accessed on</div>
													<div class="device-activity-head">
														{{ j.lastAccess }}
													</div>
												</div>
											</div>
										</div>
									</div>
									<div
										v-if="
											index < device.length - 1 ||
											(index2 < i.sessions.length - 1 &&
												i.sessions[index2].current != true)
										"
										class="visibility-line"
									></div>
								</div>
							</div>
						</div>

						<div
							class="mt-4 d-flex align-items-center justify-content-end"
							v-if="!showDeviceActivityShimmer"
						>
							<div class="d-flex align-items-center">
								<b-button
									class="candash-addBtn ml-3 pointer"
									@click="$bvModal.show('suresignout-2')"
								>
									Log out all devices
								</b-button>
							</div>
						</div>
					</div>

					<div class="profile-sub-containers mt-2" id="visibility">
						<div v-if="showVisibilityShimmer">
							<b-skeleton class="h-25 w-25"></b-skeleton>
						</div>
						<div
							class="d-flex align-items-center justify-content-between"
							v-else
						>
							<div class="profile-containers-head">Visibility</div>
							<div>
								<!-- class="profile-switch" -->
								<b-form-checkbox
									switch
									class="visibility-unselected-profile-switch"
									size="lg"
									v-model="visibility"
									@change="allUserSettings()"
								></b-form-checkbox>
								<!-- <b-form-checkbox
                  switch
                  class="visibility-unselected-profile-switch"
                  size="lg"
                ></b-form-checkbox> -->
							</div>
						</div>
						<div class="mt-2 started-at" v-if="!showVisibilityShimmer">
							Make certain sections visible from My profile
						</div>
						<div class="mt-4 w-100" v-if="showVisibilityShimmer">
							<b-row class="ml-1" v-for="(i, index) in loopvar" :key="index">
								<b-skeleton class="ml-3 mt-4 w-85 h-25"></b-skeleton>
							</b-row>
						</div>
						<div class="mt-4 w-100" v-else>
							<b-row class="ml-1">
								<b-col
									:cols="i.formName === 'Personal Details' ? 12 : 6"
									v-for="(i, index) in visibilityList"
									:key="index"
									class="mt-2"
								>
									<b-row>
										<b-col :cols="i.formName === 'Personal Details' ? 4 : 12">
											<div
												class="d-flex align-items-center justify-content-between"
											>
												<div class="visibility-head">
													{{ i.formName }}
												</div>
												<div>
													<b-form-checkbox
														switch
														class="profile-switch"
														v-model="i.status"
														@change="changeUserSettings('parent')"
													></b-form-checkbox>
												</div>
											</div>
										</b-col>
									</b-row>

									<template v-if="i.hasVisibilityFields">
										<b-row class="mt-2">
											<b-col
												cols="4"
												v-for="(field, fieldIndex) in i.visibilityFieldsList"
												:key="fieldIndex"
												class="mb-2"
											>
												<div
													class="d-flex align-items-center justify-content-between"
												>
													<span class="visibility-head">{{ field.label }}</span>
													<b-form-checkbox
														switch
														class="profile-switch"
														v-model="field.status"
														@change="changeUserSettings('child')"
													></b-form-checkbox>
												</div>
											</b-col>
										</b-row>
									</template>

									<div
										v-if="index != 8 && index != 9"
										class="visibility-line"
									></div>
								</b-col>
							</b-row>
						</div>
					</div>

					<div class="profile-sub-containers mt-2" id="delete">
						<div>
							<div v-if="showVisibilityShimmer">
								<b-skeleton class="w-25 h-25"></b-skeleton>
							</div>
							<div v-else class="profile-containers-head">Disable Account</div>
							<div v-if="showVisibilityShimmer">
								<b-skeleton class="mt-4 w-85 h-25"></b-skeleton>
							</div>
							<div
								v-else
								class="mt-2 d-flex align-items-center justify-content-between"
							>
								<div class="started-at width-80">
									Temporarily disable your account to restrict access and
									maintain privacy; enable anytime for full access.
								</div>
								<div class="width-20">
									<div class="d-flex align-items-center w-100">
										<b-button
											class="profile-disableBtn ml-3 pointer w-100"
											v-b-modal.disableModal
											v-if="!isDisabled"
										>
											Disable Account
										</b-button>
										<b-button
											class="profile-disableBtn ml-3 pointer w-100"
											@click="disableAccount()"
											v-else
										>
											Enable Account
										</b-button>
									</div>
								</div>
							</div>
							<div class="visibility-line"></div>
						</div>
						<div class="mt-2">
							<div v-if="showVisibilityShimmer">
								<b-skeleton class="w-25 h-25"></b-skeleton>
							</div>
							<div v-else class="profile-containers-head">Delete Account</div>
							<div v-if="showVisibilityShimmer">
								<b-skeleton class="mt-4 w-85 h-25"></b-skeleton>
							</div>
							<div
								v-else
								class="mt-2 d-flex align-items-center justify-content-between"
							>
								<div class="started-at width-80">
									Account deletion is irreversible. Once the process is
									complete, all data associated with your account cannot be
									recovered.
								</div>
								<div class="width-20" v-if="!delDetails && !verifyEmail">
									<div class="d-flex align-items-center w-100">
										<b-button
											class="profile-deletedBtn ml-3 pointer w-100"
											@click="
												(delDetails = true),
													(selected = []),
													(otherReason = '');
												$v.otherReason.$reset();
											"
										>
											Delete Account
										</b-button>
									</div>
								</div>
							</div>
							<div class="mt-4" v-if="delDetails">
								<div class="delDetails-head">
									{{ profileDetails.firstName + "" + profileDetails.lastName }},
									We're sorry to see you go
								</div>
								<div class="started-at mt-2">
									Tell us reason for closing your account
								</div>
								<div class="mt-2">
									<b-form-checkbox
										v-for="option in delDetailsOptions"
										:key="option.value"
										v-model="selected"
										:value="option.value"
										:unchecked-value="null"
										:id="'checkbox-' + option.value"
										:class="
											delDetailsNext
												? 'delDetailsNext-checkbox'
												: 'profile-checkbox'
										"
									>
										<div class="text-center">
											{{ option.text }}
										</div>
									</b-form-checkbox>
								</div>
								<div
									class="mt-2 d-flex align-items-center"
									:class="
										delDetailsNext || showOtherReasonTextarea
											? 'justify-content-between'
											: 'justify-content-end'
									"
								>
									<div class="pwidth-60">
										<div
											v-if="delDetailsNext && selected !== '6'"
											class="d-flex align-items-center w-100"
										>
											<div>
												<img src="../assets/New Profile/reqIcons.svg" alt="" />
											</div>
											<div class="ml-3 required-font">
												Please fill the required fields
											</div>
										</div>
										<div v-else-if="showOtherReasonTextarea" class="w-100 ml-4">
											<div class="w-100">
												<!-- use this class for validation -- error-inputField -->
												<b-form-textarea
													:class="
														$v.otherReason.$error ? 'error-inputField' : ''
													"
													class="profile-inputField"
													rows="2"
													max-rows="2"
													no-resize
													placeholder="Enter"
													v-model="otherReason"
													@input="updateCharacterCount"
													:maxlength="200"
												>
												</b-form-textarea>
											</div>
											<div
												class="validation-started-at mt-1"
												v-if="$v.otherReason.$dirty && !$v.otherReason.required"
											>
												This field is required if you select others
											</div>

											<div class="started-at" v-else>
												{{ charactersLeft }} characters left
											</div>
										</div>
									</div>
									<div class="d-flex align-items-center mb-4">
										<b-button
											class="candash-cancelBtn pointer"
											@click="
												(delDetails = false),
													(otherReason = ''),
													$v.otherReason.$reset()
											"
										>
											Cancel
										</b-button>

										<template>
											<b-button
												class="candash-addBtn ml-3 pointer"
												@click="verifyEmailAddress()"
												:disabled="selected.length == 0"
											>
												Verify Email
											</b-button>
											<!-- <b-button
                        v-else
                        class="candash-addBtn ml-3 pointer"
                        @click="delDetailsNext = true"
                      >
                        Next
                      </b-button> -->
										</template>
									</div>
								</div>
							</div>
							<div v-else-if="verifyEmail == true" class="mb-3">
								<div class="mt-4 d-flex align-items-center w-100">
									<div @click="$bvModal.hide('disableModal')">
										<img
											src="../assets/New Profile/verification-icon.svg"
											alt=""
										/>
									</div>

									<div class="ml-3">
										<div class="verfify-font-head">
											Verify your email to Delete Account
										</div>
										<div class="verfify-font-subhead mt-1">
											Check the email that's associated with your account for
											the verification code
										</div>
									</div>
								</div>
								<div class="mt-3 d-flex align-items-center pwidth-60">
									<div class="width-23">
										<label class="candash-modal-label width-130px"
											>Verification Code</label
										>
									</div>
									<div class="width-50">
										<b-form-input
											:class="
												otpWrong || otpExists || otpExpired
													? 'error-inputField'
													: ''
											"
											class="profile-inputField"
											placeholder="Enter Code"
											v-model="verificationCode"
											type="text"
										>
										</b-form-input>
										<div
											v-if="verificationCode != null && otpWrong"
											class="newPass-validation-font mt-1"
										>
											OTP is invalid.
										</div>
										<div
											v-else-if="verificationCode != null && otpExists"
											class="newPass-validation-font mt-1"
										>
											OTP does not exist.
										</div>
										<div
											v-else-if="verificationCode != null && otpExpired"
											class="newPass-validation-font mt-1"
										>
											OTP is expired.
										</div>
									</div>
								</div>

								<div class="mt-4 d-flex align-items-center justify-content-end">
									<div class="d-flex align-items-center">
										<div class="d-flex align-items-center">
											<b-button
												class="candash-cancelBtn pointer"
												@click="(verifyEmail = false), (delDetails = false)"
											>
												Cancel
											</b-button>
											<b-button
												class="candash-addBtn ml-3 pointer"
												@click="
													(deviceSignOut = false),
														deleteAccount(),
														signOutAllDevices()
												"
												:disabled="verificationCode == null"
											>
												Delete
											</b-button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="profile-sub-containers mt-2" id="query">
						<div v-if="showVisibilityShimmer">
							<b-skeleton class="h-25 w-25"></b-skeleton>
						</div>
						<div
							class="profile-sub-containers mt-2"
							id="InvoiceDownload"
							v-if="candidateTicketHistory && candidateTicketHistory.length"
						>
							<div class="d-flex justify-content-between align-items-center">
								<div class="profile-containers-head">Track Tickets</div>
								<b-button
									class="candash-addBtn ml-3 pointer"
									@click="showReportModal = true"
								>
									Raise a Query
								</b-button>
							</div>

							<div class="mt-2 started-at">Track & manage your tickets</div>
							<b-container class="profile-table-container mt-4">
								<b-row class="profile-header ml-0 mr-0 pb-2">
									<b-col cols="2">
										Ticket ID
										<img
											class="ml-1"
											src="../assets/New Profile/blackDownArrow.svg"
											alt=""
										/>
									</b-col>
									<b-col cols="2">
										Category
										<img
											class="ml-1"
											src="../assets/New Profile/blackDownArrow.svg"
											alt=""
										/>
									</b-col>
									<b-col cols="3">
										Reason
										<img
											class="ml-1"
											src="../assets/New Profile/blackDownArrow.svg"
											alt=""
										/>
									</b-col>
									<b-col cols="2">
										Raised On
										<img
											class="ml-1"
											src="../assets/New Profile/blackDownArrow.svg"
											alt=""
										/>
									</b-col>
									<b-col cols="2">
										Status
										<img
											class="ml-1"
											src="../assets/New Profile/blackDownArrow.svg"
											alt=""
										/>
									</b-col>
									<b-col cols="1" class="pl-0">Action</b-col>
								</b-row>
								<div class="profile-table-overflow">
									<b-row
										class="profile-blue-row"
										v-for="(ticket, index) in candidateTicketHistory"
										:key="index"
									>
										<b-col cols="2">{{ ticket.ticketID }}</b-col>
										<b-col
											cols="2"
											:class="{
												'text-reviews': ticket.module === '1',
												'text-community': ticket.module === '2',
												'text-interview': ticket.module === '3',
												'text-platform': ticket.module === '5',
												'text-course':
													ticket.module !== '1' &&
													ticket.module !== '2' &&
													ticket.module !== '3',
											}"
											>{{
												ticket.module === "1"
													? "Reviews"
													: ticket.module === "2"
													? "Community"
													: ticket.module === "3"
													? "Interview"
													: ticket.module === "5"
													? "Platform"
													: "Course"
											}}</b-col
										>
										<b-col cols="3">{{ ticket.title }}</b-col>
										<b-col cols="2">{{ formatDate(ticket.createdAt) }}</b-col>
										<!-- <b-col cols="2" :class="ticket.status === '5' ? 'text-closed' : 'text-open'">Open</b-col> -->
										<b-col
											cols="2"
											class="d-flex flex-column align-items-start"
										>
											<span
												:class="
													ticket.status === '5'
														? 'text-closed'
														: ticket.status === '4'
														? 'text-appealed'
														: 'text-open'
												"
												>{{
													ticket.status === "2"
														? "Processing"
														: ticket.status === "3"
														? "Rejected"
														: ticket.status === "4"
														? "Appeal"
														: ticket.status === "5"
														? "Closed"
														: "Open"
												}}</span
											>
											<span
												v-if="ticket.status === '5' && closedActivity(ticket)"
												>{{ formatDate(closedActivity(ticket).activityAt) }}
											</span>
										</b-col>
										<b-col cols="1" class="pl-0 pointer">
											<img
												@click="showTicketInfo(ticket)"
												src="../assets/img/viewinterview/eye-icon.svg"
												alt=""
											/>
										</b-col>
									</b-row>
								</div>
							</b-container>
							<!-- <div
							v-if="candidateTicketHistory.length === 0"
							class="d-flex flex-column align-items-center justify-content-center w-100"
						>
							<img src="../assets/New Profile/noTransaction.svg" alt="" />
							<span class="upCandDoc-unselected-box-head mt-2"
								>You haven’t made any transactions yet.</span
							>
						</div> -->
						</div>
						<div v-else>
							<div class="profile-containers-head">Raise A Query</div>
							<!-- add image here -->

							<div class="mt-1 w-100 text-center" v-if="!raiseQuery">
								<div
									v-if="showPersonalDataShimmer"
									class="mt-3 d-flex justify-content-center w-100"
								>
									<b-skeleton-img
										no-aspect
										height="155px"
										width="268px"
									></b-skeleton-img>
								</div>
								<img src="@/assets/New Profile/Query-img.svg" alt="" />
								<!-- <div
									class="mt-3 d-flex justify-content-center raise-button-shimmer"
									v-if="showPersonalDataShimmer"
								>
									<b-skeleton type="button"></b-skeleton>
								</div> -->
								<div class="mt-3 d-flex justify-content-center w-100">
									<b-button
										class="candash-addBtn ml-3 pointer"
										@click="showReportModal = true"
									>
										Raise Query
									</b-button>
								</div>
							</div>

							<div class="mt-3 w-100 relativeclass" v-if="raiseQuery">
								<div class="row align-items-start">
									<div class="col-4">
										<div class="pd-txt" style="margin-top: 20px">
											Explain Your Concern<span style="color: #eb0002">*</span>
										</div>
									</div>
									<div class="col-8">
										<b-form-textarea
											class="profile-inputField"
											rows="2"
											max-rows="2"
											no-resize
											placeholder="Enter"
											v-model="otherReason"
											@input="updateCharacterCount"
											:maxlength="200"
										></b-form-textarea>
										<div class="started-at">
											{{ charactersLeft }} characters left
										</div>
									</div>
								</div>

								<div class="mt-4 d-flex align-items-center justify-content-end">
									<b-button
										class="candash-cancelBtn ml-3 pointer"
										@click="cancelRaiseQuery"
									>
										Cancel
									</b-button>

									<b-button
										class="candash-addBtn ml-3 pointer"
										@click="submitQuery"
										:disabled="otherReason == ''"
									>
										Submit
									</b-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<b-modal id="disableModal" size="md" centered hide-footer hide-header>
			<div class="d-flex">
				<div class="width-15">
					<img src="../assets/New Profile/warning-icon.svg" alt="" />
				</div>
				<div class="width-85">
					<div class="d-flex align-items-center justify-content-between">
						<div class="profile-containers-head mt-2">
							Warning : Account Disabling
						</div>
						<div class="pointer" @click="$bvModal.hide('disableModal')">
							<img src="../assets/New Profile/close-icon.svg" alt="" />
						</div>
					</div>
					<div class="mt-1 disable-modal-subfont">
						Disabling your account will:
					</div>
					<div class="mt-3 disable-modal-subfont">
						<ul>
							<li>Restrict job-related activities</li>
							<li class="mt-2">Hide your profile from all users</li>
							<li class="mt-2">Recruiters cannot search your profile</li>
						</ul>
					</div>

					<div class="mt-4 d-flex align-items-center justify-content-end">
						<b-button
							class="candash-addBtn ml-3 pointer"
							@click="disableAccount(), $bvModal.hide('disableModal')"
						>
							Okay
						</b-button>
					</div>
				</div>
			</div>
		</b-modal>

		<b-modal id="deleteAcc" size="md" centered hide-footer hide-header>
			<div
				class="d-flex align-items-center Justify-content-center w-100 flex-column"
			>
				<div class="mt-2">
					<img src="../assets/New Profile/delete-icon.svg" alt="" />
				</div>
				<div class="mt-2 profile-containers-head">Your account is deleted</div>
				<div class="mt-2 started-at">Thanks for using our product</div>
				<div class="mt-4">
					<b-button
						class="candash-addBtn ml-3 pointer"
						@click="
							(deviceSignOut = false), logout(), $bvModal.hide('deleteAcc')
						"
					>
						Okay
					</b-button>
				</div>
			</div>
		</b-modal>

		<b-modal id="suresignout-2" size="md" centered hide-footer hide-header>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-top no-border-bottom p-3 mt-2">
						<div class="width-10">
							<img
								class="mr-3 ml-2"
								src="../assets/mobile/accset/mb-signout-2.svg"
								alt=""
							/>
						</div>
						<div class="w87">
							<div class="d-flex">
								<div class="mb-header-txt">
									Are you sure you want to log out of
									{{ selectedDevice == null ? "all devices" : "this device" }}?
								</div>
								<div
									class="d-flex justify-content-end pointer cross-icon-pos"
									@click="
										(selectedDevice = null), $bvModal.hide('suresignout-2')
									"
								>
									<img
										class="rotate-on-hover"
										src="../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>

					<div
						class="p-3 no-border-top d-flex align-items-center justify-content-end"
					>
						<b-button
							class="candash-cancelBtn mr-4"
							@click="(selectedDevice = null), $bvModal.hide('suresignout-2')"
							>Cancel</b-button
						>
						<div class="position-relative">
							<b-button
								class="candash-addBtn"
								:class="
									loading ? 'loader-class-signout defaultCursor' : 'pointer'
								"
								@click="
									selectedDevice == null
										? ((deviceSignOut = true), signOutAllDevices())
										: signOut(selectedDevice)
								"
							>
								<span v-if="!loading">Log Out</span>
							</b-button>
							<div v-if="loading" class="loader-pos-new">
								<Loader />
							</div>
						</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal id="signedout" centered hide-footer hide-header>
			<div class="d-flex flex-column align-items-center p-2">
				<div>
					<img src="../assets/toast/successBig.svg" alt="" />
				</div>
				<div class="mb-header-txt mt-3 text-center">
					You have been signed out of all<br />
					devices.
				</div>
				<div class="upCandDoc-unselected-box-head-2 mt-1"></div>
				<div class="mt-4">
					<b-button class="mb-addBtn" @click="$bvModal.hide('signedout')"
						>Okay</b-button
					>
				</div>
			</div>
		</b-modal>
		<b-modal
			id="submitQuery"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="d-flex align-items-center justify-content-between w-100">
				<div class="d-flex align-items-center w-100">
					<div class="mb-5">
						<img
							src="../assets/newdesign/dashboard/submitted-icon.svg"
							alt=""
						/>
					</div>
					<div class="ml-3 w-100">
						<div class="d-flex justify-content-between">
							<div class="teams-modal-head">Successfully Submitted!</div>
							<div
								@click="$bvModal.hide('submitQuery')"
								class="d-flex align-items-center justify-content-end"
							>
								<img
									src="../assets/newdesign/dashboard/blueCross.svg"
									alt=""
									class="pointer rotate-on-hover"
								/>
							</div>
						</div>
						<div class="d-flex justify-content-between">
							<div class="mt-2 teams-delete-folder-font" style="width: 80%">
								Please Note Ticket No. for further reference.
							</div>
							<div
								class="mt-2 teams-delete-folder-font"
								style="width: 20%"
								v-if="linkCopied"
							>
								<img src="../assets/newdesign/dashboard/greyTick.svg" alt="" />
								copied
							</div>
						</div>

						<div
							class="mt-2 submitQuey-ticketNo d-flex align-items-center justify-content-between w-100"
						>
							<div>{{ ticketId }}</div>
							<div>
								<img
									class="pointer"
									@click="copyTheLink(ticketId)"
									src="../assets/newdesign/assessPro/copy.svg"
									alt=""
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
				<b-button
					class="candash-cancelBtn ml-3 pointer"
					@click="$bvModal.hide('submitQuery')"
				>
					Close
				</b-button>
			</div>
		</b-modal>
		<b-modal
			v-model="showTicketInfoModal"
			id="ticketInfoModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<header class="candash-modal-top p-3">
				<div class="fam-lato fw-LM fs-18 color-595959">
					Ticket ID : <span class="text-blue">{{ ticketInfo.ticketID }}</span>
				</div>
				<div class="d-flex justify-content-end pointer">
					<img
						@click="$bvModal.hide('ticketInfoModal')"
						class="rotate-on-hover"
						src="../assets/newdesign/dashboard/blueCross.svg"
						alt=""
					/>
				</div>
			</header>
			<div class="tim-scroll">
				<div class="fam-mont fw-LM fs-13 text-3A3C40">Raised on</div>
				<div class="fam-mont fw-M fs-14 text-3A3C40 mt-1">
					{{ formatDate(ticketInfo.createdAt) }}
				</div>
				<div class="fam-mont fw-LM fs-13 text-3A3C40 mt-3">Status</div>
				<div
					class="fam-mont fw-M fs-14 text-00ae1c"
					:class="
						ticketInfo.status === '5'
							? 'text-closed'
							: ticketInfo.status === '4'
							? 'text-appealed'
							: 'text-open'
					"
				>
					{{
						ticketInfo.status === "2"
							? "Processing"
							: ticketInfo.status === "3"
							? "Rejected"
							: ticketInfo.status === "4"
							? "Appeal"
							: ticketInfo.status === "5"
							? "Closed"
							: "Open"
					}}
					<span
						class="text-3A3C40 fw-R"
						v-if="ticketInfo.status == '5' && closedActivity(ticketInfo)"
						>({{ formatDate(closedActivity(ticketInfo).activityAt) }})</span
					>
				</div>
				<div class="fam-mont fw-LM fs-13 text-3A3C40 mt-3">Category:</div>
				<div
					class="fam-mont fw-M fs-14"
					:class="{
						'text-reviews': ticketInfo.module === '1',
						'text-community': ticketInfo.module === '2',
						'text-interview': ticketInfo.module === '3',
						'text-platform': ticketInfo.module === '5',
						'text-course':
							ticketInfo.module !== '1' &&
							ticketInfo.module !== '2' &&
							ticketInfo.module !== '3',
					}"
				>
					{{
						ticketInfo.module === "1"
							? "Reviews"
							: ticketInfo.module === "2"
							? "Community"
							: ticketInfo.module === "3"
							? "Interview"
							: ticketInfo.module === "5"
							? "Platform"
							: "Course"
					}}
				</div>
				<div class="fam-mont fw-LM fs-13 text-3A3C40 mt-3">Reason</div>
				<div class="fam-mont fw-M fs-14 text-3A3C40 mt-1 word-break">
					{{ ticketInfo.title }}
				</div>
				<div class="fam-mont fw-LM fs-13 text-3A3C40 mt-3">Remark</div>
				<div class="fam-mont fw-M fs-14 text-3A3C40 mt-1 word-break">
					{{ ticketInfo.remarks }}
				</div>

				<div
					class="fam-mont fw-500 fs-13 text-3A3C40 mt-3 d-flex"
					v-if="closedActivity(ticketInfo) && ticketInfo.status == '5'"
				>
					<span class="stroke-line mr-3 mt-2"></span>Ticket Closing Remarks<span
						class="stroke-line ml-3 mt-2"
					></span>
				</div>
				<div
					class="mt-3"
					v-if="closedActivity(ticketInfo) && ticketInfo.status == '5'"
				>
					<b-card
						no-body
						class="overflow-hidden w-100 lb-right-card position-relative p-3 admin-card"
					>
						<div class="d-flex align-items-center justify-content-between">
							<div class="fw-LM fs-16 fam-lato">
								<img src="../assets/newdesign/dashboard/admin.svg" alt="" />
								<span class="admin ml-2">Super Admin:</span>
							</div>
							<span>{{
								formatDate(closedActivity(ticketInfo).activityAt)
							}}</span>
						</div>
						<hr class="my-2" style="border-top: 1px solid #888888" />
						<!-- title -->
						<div class="fam-mont fw-400 fs-13 mt-2">Reason:</div>
						<div class="fam-lato fw-400 fs-13 text-darkgrey word-break">
							{{ closedActivity(ticketInfo).title }}
						</div>

						<div class="fam-mont fw-400 fs-13 mt-2">Remark:</div>
						<div class="fam-lato fw-400 fs-14 lh-18 text-darkgrey word-break">
							{{ closedActivity(ticketInfo).remarks }}
						</div>
					</b-card>
				</div>
			</div>
		</b-modal>
		<ReportIssueModal
			v-if="showReportModal"
			:showModal="showReportModal"
			:reportIssue="reportIssue"
			:isCommon="true"
			:interviewId="userInfo.userID"
			@closeReport="showReportModal = false"
			@updateReport="viewTicketHistory"
		/>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
const qs = require("qs");
import errorModal from "../components/mixin/toast.js";
import successModal from "../components/mixin/toast.js";
import Spinner from "../components/fixedcomponents/Spinner.vue";
import Loader from "../components/fixedcomponents/Loader.vue";
import ReportIssueModal from "@/components/JobProgress/ReportIssueModal.vue";
import {
	required,
	email,
	maxLength,
	helpers,
	numeric,
	requiredIf,
} from "vuelidate/lib/validators";
import { getLoginType } from "../utils/tokenCheck";
import { Capacitor } from "@capacitor/core";
import {
	getDeviceActivity,
	signOutDevices,
	signOutAllDevices,
	userLogin,
	resetPassword,
	saveProfileDetails,
	getUserDetails,
	getUserSettings,
	changeUserSettings,
	deleteAccount,
	userInfo,
	raiseQuery,
	viewTicketHistory,
	checkCandidateSignin,
} from "../utils/apiFunctions";
import trackAccountDeleted from "../utils/posthogHelpers"
import { notGoogleLogin } from "@/utils/tokenCheck.js";
export default {
	name: "Profile",
	mixins: [errorModal, successModal],

	components: {
		Spinner,
		Loader,
		ReportIssueModal,
	},
	directives: {
		"no-copy-paste": {
			inserted(el) {
				el.addEventListener("copy", (event) => {
					event.preventDefault();
				});
				el.addEventListener("paste", (event) => {
					event.preventDefault();
				});
			},
		},
	},
	data() {
		return {
			showReportModal: false,
			reportIssue: {
				1: "Didn’t receive timely support",
				2: "Difficult to contact support",
				3: "Issue unresolved",
				4: "Faced a technical error or bug",
				5: "Login or access issue",
				6: "Page not loading properly",
				7: "Notification/email not received",
				8: "Poor content quality",
				9: "Platform is slow or unresponsive",
				10: "Others",
			},
			showTicketInfoModal: false,
			linkCopied: false,
			ticketId: null,
			concern: "",
			raiseQuery: false,
			matchCriteria: false,
			isDisabled: false,
			deviceSignOut: false,
			profileLoader: false,
			Loader: false,
			editPhn: false,
			maxCharacters: 200,
			activeSec: null,
			checkNewPsw: false,
			showPersonalDataShimmer: false,
			showDeviceActivityShimmer: false,
			showBasicAuthShimmer: false,
			showVisibilityShimmer: false,
			currentlyTrue: {},
			otpWrong: false,
			otpExpired: false,
			otpExists: false,
			reassign: {
				email: "",
				firstName: "",
				lastName: "",
				phoneNumber: "",
			},

			loopvar: 4,
			loopvar2: 9,
			visibilityList: [],
			visibility: false,
			userSettings: {},
			otherReason: "",
			verificationCode: null,
			createdAt: "",
			activeSection: null,
			signedOut: false,
			// new design variables start
			delDetails: false,
			delDetailsNext: false,
			verifyEmail: false,
			savedAuthentication: false,
			selectedDevice: null,
			activeTab: "personalData",
			tabIndex: 0,
			selected: [],
			allowScrollHandling: true,
			activeSection: "personalData",
			sections: [
				"personalData",
				"basicAuth",
				"deviceActivity",
				"visibility",
				"InvoiceDownload",
				"delete",
			],
			delDetailsOptions: [
				{ text: "Platform not user-friendly ", value: "1" },
				{
					text: "Found an alternative platform",
					value: "2",
				},
				{ text: "Technical issues", value: "3" },
				{
					text: "Unwanted emails and notifications",
					value: "4",
				},
				{ text: "Privacy concerns", value: "5" },
				{ text: "Other (please specify)", value: "6" },
			],
			// new design variables end
			loading: false,
			hasPassword: true,
			showCurrentPassword: false,
			showNewPassword: false,
			showConfirmPassword: false,
			// Variables to show or hide different containers/sections
			showProfInfo: false, // Show Profile Info
			showBasicAut: false, // Show Basic Authentication
			resetPassword: false, // Flag for resetting password
			showDevAct: false, // Show Device Activity
			showApp: false, // Show Application
			checkCurrentPsw: false,
			checkNewPsw: false,
			editProfile: false,
			regex: /^(.*[A-Z]){2,}.*$/,
			// Form fields for password reset
			passwordDetails: {
				confirmPswd: "",
				newPswd: "",
				currentPassword: "",
			},
			hasUppercase: false,
			hasLowercase: false,
			hasSplcharacter: false,
			hasNumber: false,

			givenPsw: "",

			email: "",
			first_Name: "",
			lastt_Name: "",
			passwordsMatch: false,

			// Profile related fields
			profileDetails: {
				email: "",
				firstName: "",
				lastName: "",
				phoneNumber: "",
			},

			// Arrays to store device activity and application data
			deviceCheck: [],
			device: [],

			getApplication: [],
			candidateTicketHistory: [],
			ticketInfo: {},
		};
	},

	computed: {
		notGoogleLogin,
		charactersLeft() {
			return this.maxCharacters - this.otherReason.length;
		},
		showOtherReasonTextarea() {
			return this.selected.includes("6");
		},
		// Mapping Vuex getters to computed properties
		...mapGetters("userVUEX", {
			User: "getUserEmail",
			selTheme: "getSelectedTheme",
			userInfo: "getUserInfo",
		}),
		...mapGetters("candidateVUEX", {
			progress: "getCandProgressResp",
		}),
	},

	validations: {
		// Validation rules for form fields
		profileDetails: {
			firstName: {
				required,
				maxLength: maxLength(38),
				alphaNumeric: helpers.regex("alphaNumeric", /^[A-Za-z. ]*$/),
			},
			phoneNumber: {
				required,
				alpha: helpers.regex("alpha", /^[6-9]\d{9}$/),
				numeric,
			},

			lastName: {
				required,
				maxLength: maxLength(38),
				alphaNumeric: helpers.regex("alphaNumeric", /^[A-Za-z. ]*$/),
			},
		},
		passwordDetails: {
			confirmPswd: {
				required,
				maxLength: maxLength(55),
			},
			newPswd: {
				required,
				maxLength: maxLength(55),
			},
			currentPassword: {
				required: requiredIf(function () {
					return this.hasPassword;
				}),
				maxLength: maxLength(55),
			},
		},
		otherReason: {
			required: requiredIf(function () {
				return this.showOtherReasonTextarea;
			}),
		},
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll);
	},

	created() {
		this.savedAuthentication = true;
		this.showBasicAuthShimmer = true;

		this.getprofileDetails();
		this.checkUserHasPassword();
		if (this.notGoogleLogin) this.getDeviceActivity();
		this.getUserSettings();
		this.viewTicketHistory();
		this.$nextTick(() => {
			this.navigate(this.$route.query.tab);
		});
	},
	watch: {
		verificationCode: function () {
			this.otpExists = false;
			this.otpExpired = false;

			this.otpWrong = false;
		},

		"passwordDetails.currentPassword": function () {
			this.checkCurrentPsw = false;

			if (
				this.passwordDetails.newPswd != this.passwordDetails.currentPassword
			) {
				this.checkNewPsw = true;
			} else {
				this.checkNewPsw = false;
			}
		},

		"passwordDetails.confirmPswd": function () {
			if (this.passwordDetails.newPswd == this.passwordDetails.confirmPswd) {
				this.passwordsMatch = true;
			} else {
				this.passwordsMatch = false;
			}
		},

		"passwordDetails.newPswd": function () {
			this.matchCriteria = false;

			if (this.passwordDetails.newPswd == this.passwordDetails.confirmPswd) {
				this.passwordsMatch = true;
			} else {
				this.passwordsMatch = false;
			}
			if (
				this.passwordDetails.newPswd != this.passwordDetails.currentPassword
			) {
				this.checkNewPsw = true;
			} else {
				this.checkNewPsw = false;
			}
		},
	},

	methods: {
		closedActivity(ticket) {
			if (!ticket || !ticket.activity) return null;

			const reversed = [...ticket.activity].reverse();
			return reversed.find((item) => item.status == "5") || null;
		},
		showTicketInfo(ticket) {
			this.showTicketInfoModal = true;
			this.ticketInfo = ticket;
		},
		formatDate(date) {
			if (!date) return "";
			if (date.includes(",")) {
				return date.slice(0, date.indexOf(","));
			}
			return date.slice(0, 10);
		},
		async viewTicketHistory() {
			const res = await viewTicketHistory();
			if (res.status == 200) {
				this.candidateTicketHistory = res.data.data;
			}
		},
		cancelRaiseQuery() {
			this.raiseQuery = false;
			this.otherReason = "";
		},
		copyTheLink(ticketId) {
			this.$copyToClipboard(ticketId);
			this.linkCopied = true;
			setTimeout(() => {
				this.linkCopied = false;
			}, 3000);
		},
		async submitQuery() {
			let payload = {
				concern: this.otherReason,
			};
			const res = await raiseQuery(payload);
			if (res.status == 200) {
				this.otherReason = "";
				this.raiseQuery = false;
				this.ticketId = res.data.data.ticketID;
				this.$bvModal.show("submitQuery");
			}
		},
		numbersOnly(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (
				charCode > 31 &&
				(charCode < 48 || charCode > 57) &&
				charCode !== 46
			) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		alphabetsOnly(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (
				(charCode < 65 || charCode > 90) &&
				(charCode < 97 || charCode > 122) &&
				charCode !== 32 && // space
				charCode !== 46 // dot
			) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		editPersonalData() {
			this.editProfile = true;
			this.reassign = JSON.parse(JSON.stringify(this.profileDetails));
			if (this.profileDetails.phoneNumber == "") {
				this.editPhn = true;
			}
		},
		async verifyEmailAddress() {
			this.verificationCode = null;
			let type = {
				type: "delete-account",
			};
			const response = await deleteAccount(type);
			console.log(response);
			this.$v.otherReason.$touch();
			if (!this.$v.otherReason.$invalid) {
				this.verifyEmail = true;
				this.delDetails = false;
			}
		},
		validatePassword() {
			this.hasUppercase = /^(.*[A-Z]){1,}.*$/.test(
				this.passwordDetails.newPswd
			);
			this.hasLowercase = /^(.*[a-z]){3}.*$/.test(this.passwordDetails.newPswd);
			this.hasSplcharacter =
				/^(.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]){1,}.*$/.test(
					this.passwordDetails.newPswd
				);
			this.hasNumber = /^(.*\d){1,}.*$/.test(this.passwordDetails.newPswd);
		},
		async disableAccount() {
			let payload = {
				isDisabled: !this.isDisabled,
			};
			const res = await changeUserSettings(payload);
			if (res.status == 200) {
				this.isDisabled = res.data.data.isDisabled;
				console.log(this.isDisabled, "kk");
				if (this.isDisabled == false) {
					this.successModal(
						"Successfully Enabled",
						"Your Account have been enabled"
					);
				}
				this.callingRegisterAPI();
			}
		},
		updateCharacterCount() {
			this.$v.otherReason.$touch();
			if (this.charactersLeft < 0) {
				// Trim the input if the character limit is exceeded
				this.otherReason = this.otherReason.slice(0, this.maxCharacters);
			}
		},

		async logout() {
			// this.signOutAllDevices();
			let payload = {
				id: this.currentlyTrue.id,
			};
			await signOutDevices(payload);
			this.$socket.emit("signOut", {
				email: this.profileDetails.email,
				userid: payload,
			});
			localStorage.clear();
			this.$store.dispatch("userVUEX/LogOut");
			// this.$router.push(`/login?redirect=${this.$route.fullPath}`);
			location.reload();
		},
		async deleteAccount() {
			let payload = {
				isDeleted: {
					status: true,
					reasons: this.selected,
					otherReason: this.otherReason,
				},
				otp: parseInt(this.verificationCode),
			};
			const res = await changeUserSettings(payload);
			if (res.status == 200) {
				trackAccountDeleted({
					email:this.profileDetails.email,
					reason:this.selected,
					otherReason:this.otherReason
				})
				this.$bvModal.show("deleteAcc");
			} else if (res.status == 401) {
				this.otpWrong = true;
			} else if (res.status == 404) {
				this.otpExists = true;
			} else if (res.status == 410) {
				this.otpExpired = true;
			} else if (res.status == 500) {
				this.errorModal("Error", "Something went wrong"); // Show error toast
			}
		},
		handleScroll(event) {
			if (!this.allowScrollHandling) return;
			console.log("called");
			const scrollTop = event.target.scrollTop;
			const windowHeight = event.target.clientHeight;
			const scrollHeight = event.target.scrollHeight;
			const scrollPosition = scrollTop + windowHeight;

			const isAtBottom = scrollPosition >= scrollHeight - 30;
			if (isAtBottom) {
				this.activeTab = "raiseQuery";
				return;
			}
			const scrollThreshold = scrollTop + 450;
			if (scrollTop === 0 && scrollThreshold === 450) {
				this.activeTab = "personalData";
				return;
			}

			const activeSection = this.sections.find((section) => {
				const el = document.getElementById(section);
				if (el) {
					const isInSection =
						el.offsetTop <= scrollThreshold &&
						el.offsetTop + el.offsetHeight > scrollThreshold;

					return isInSection;
				}
				return false;
			});
			if (activeSection) {
				this.activeSection = activeSection;

				// Map sections to corresponding tabs
				const sectionToTabMapping = {
					personalData: "personalData",
					basicAuth: "basisAuthentication",
					deviceActivity: "deviceActivity",
					visibility: "visibility",
					InvoiceDownload: "InvoiceDownload",
					delete: "deleteAccount",
				};
				this.activeTab = sectionToTabMapping[activeSection];
			}
		},
		navigate(name) {
			this.allowScrollHandling = false;
			let element = null;

			if (name === "personalData") {
				element = document.getElementById("personalData");
				this.activeTab = "personalData";
			} else if (name === "basisAuthentication") {
				element = document.getElementById("basicAuth");
				this.activeTab = "basisAuthentication";
			} else if (name === "deviceActivity") {
				element = document.getElementById("deviceActivity");
				this.activeTab = "deviceActivity";
			} else if (name === "visibility") {
				element = document.getElementById("visibility");
				this.activeTab = "visibility";
			} else if (name === "InvoiceDownload") {
				element = document.getElementById("InvoiceDownload");
				this.activeTab = "InvoiceDownload";
			} else if (name === "deleteAccount") {
				element = document.getElementById("delete");
				this.activeTab = "deleteAccount";
			} else if (name === "query") {
				element = document.getElementById("query");
				this.activeTab = "raiseQuery";
			}

			console.log("navigate - name:", name);
			console.log("navigate - element:", element);

			if (element) {
				element.scrollIntoView({
					behavior: "smooth",
					block: "start",
				});
				setTimeout(() => {
					this.allowScrollHandling = true;
				}, 1000);
			}
		},

		togglePasswordVisibility(field) {
			this[field] = !this[field];
		},
		cancelResetPswd() {
			this.$v.$reset();
			this.resetPassword = false;
			this.passwordDetails = {
				currentPassword: "",
				newPassword: "",
				confirmPswd: "",
			};
		},
		// Method to reset the password
		async resetPwd() {
			try {
				// Validate form fields
				this.$v.passwordDetails.$touch();

				// Set loading status to true
				if (
					this.passwordDetails.confirmPswd != "" &&
					this.passwordDetails.newPswd != "" &&
					(!this.hasUppercase ||
						!this.hasLowercase ||
						!this.hasNumber ||
						!this.hasSplcharacter)
				) {
					this.matchCriteria = true;
				} else if (
					this.passwordDetails.confirmPswd != "" &&
					this.passwordDetails.newPswd != "" &&
					this.hasUppercase &&
					this.hasLowercase &&
					this.hasNumber &&
					this.hasSplcharacter
				) {
					this.matchCriteria = false;
				}

				if (this.hasPassword) {
					if (
						this.passwordDetails.newPswd != this.passwordDetails.currentPassword
					) {
						this.checkNewPsw = true;
					} else {
						this.checkNewPsw = false;
					}
				} else {
					this.checkNewPsw = true;
				}

				// Check if form fields are not invalid
				if (
					!this.$v.passwordDetails.$invalid &&
					this.passwordsMatch == true &&
					this.checkNewPsw == true &&
					this.hasUppercase == true &&
					this.hasLowercase == true &&
					this.hasSplcharacter == true &&
					this.hasNumber == true &&
					this.matchCriteria == false
				) {
					this.Loader = true;
					let username = this.userInfo.email;

					if (!this.hasPassword) {
						// Set password flow: user has no password yet — call resetPassword directly
						let userpayload = {
							email: username,
							password: this.passwordDetails.confirmPswd,
						};
						const res = await resetPassword(userpayload);
						if (res.status == 200) {
							this.savedAuthentication = true;
							this.hasPassword = true;
							this.Loader = false;
							this.hasUppercase = false;
							this.hasLowercase = false;
							this.hasSplcharacter = false;
							this.hasNumber = false;
							this.$v.$reset();
							this.successModal("Success", "Password set successfully!");
							this.passwordDetails = {
								currentPassword: "",
								newPassword: "",
								confirmPswd: "",
							};
						} else {
							this.Loader = false;
							this.errorModal("Error", "Something went wrong");
						}
					} else {
						// Normal flow: verify current password via Keycloak first
						let payload = qs.stringify({
							grant_type: "password",
							client_id: "vue-test-app",
							username: username,
							password: this.passwordDetails.currentPassword,
						});
						// Send user login request
						const res = await userLogin(payload);
						if (res.status == 200) {
							// If login successful, prepare payload to reset password
							let userpayload = {
								email: username,
								password: this.passwordDetails.confirmPswd,
							};
							// Call the API to reset the password
							const res = await resetPassword(userpayload);
							if (res.status == 200) {
								this.savedAuthentication = true; // Set resetPassword flag to false

								this.Loader = false;
								this.hasUppercase = false;
								this.hasLowercase = false;
								this.hasSplcharacter = false;
								this.hasNumber = false;
								this.$v.$reset();
								this.successModal(
									"Successfully updated",
									"Password have been updated"
								); // Show success toast
								this.passwordDetails = {
									currentPassword: "",
									newPassword: "",
									confirmPswd: "",
								};
							} else if (res.status == 401) {
								this.checkCurrentPsw = true;
								this.errorModal("Error", "Something went wrong"); // Show error toast
							}
						}
					}
				}
			} catch (error) {
				this.Loader = false;

				this.checkCurrentPsw = true;
				this.errorModal("Error", "Invalid user credentials");

				console.error("Error:", error); // Log the error to the console
			}
		},
		async getUserSettings() {
			this.showVisibilityShimmer = true;
			const res = await getUserSettings();

			this.userSettings = res.data.data.visibilityConfig;
			this.visibilityList = res.data.data.visibilityList;
			this.isDisabled = res.data.data.isDisabled;
			if (this.visibilityList.every((item) => item.status === false)) {
				this.visibility = false;
			} else if (this.visibilityList.every((item) => item.status === true)) {
				this.visibility = true;
			}
		},
		async allUserSettings() {
			try {
				this.visibilityList.forEach((item) => {
					item.status = this.visibility;

					if (
						item.hasVisibilityFields &&
						item.visibilityFieldsList.length > 0
					) {
						item.visibilityFieldsList.forEach((field) => {
							field.status = this.visibility;
						});
					}
				});

				const visibilityConfig = {};

				this.visibilityList.forEach((item) => {
					visibilityConfig[item.formID] = item.status;

					if (
						item.hasVisibilityFields &&
						item.visibilityFieldsList.length > 0
					) {
						let subFieldConfig = {};
						item.visibilityFieldsList.forEach((field) => {
							subFieldConfig[field.key] = field.status;
						});
						visibilityConfig[item.formID + "_Fields"] = subFieldConfig;
					}
				});

				const payload = {
					visibilityConfig,
				};

				await changeUserSettings(payload);
			} catch (error) {
				console.error("Error in allUserSettings:", error);
			}
		},

		async changeUserSettings(source = "child") {
			try {
				let visibilityConfig = {};

				this.visibilityList.forEach((item) => {
					if (source === "parent") {
						if (item.status && item.hasVisibilityFields) {
							item.visibilityFieldsList.forEach((field) => {
								field.status = true;
							});
						}

						if (!item.status && item.hasVisibilityFields) {
							item.visibilityFieldsList.forEach((field) => {
								field.status = false;
							});
						}
					}

					if (source === "child") {
						if (item.hasVisibilityFields && item.visibilityFieldsList.length) {
							const allOn = item.visibilityFieldsList.every(
								(field) => field.status
							);
							const allOff = item.visibilityFieldsList.every(
								(field) => !field.status
							);
							if (allOn) {
								item.status = true;
							} else if (allOff) {
								item.status = false;
							}
						}
					}

					visibilityConfig[item.formID] = item.status;

					if (item.hasVisibilityFields) {
						let subFieldConfig = {};
						item.visibilityFieldsList.forEach((field) => {
							subFieldConfig[field.key] = field.status;
						});
						visibilityConfig[item.formID + "_Fields"] = subFieldConfig;
					}
				});

				const allVisible = this.visibilityList.every((item) => item.status);
				const allHidden = this.visibilityList.every((item) => !item.status);
				this.visibility = allVisible
					? true
					: allHidden
					? false
					: this.visibility;

				await changeUserSettings({ visibilityConfig });
			} catch (error) {
				console.error("Error in changeUserSettings:", error);
			}
		},
		// Method to check if user has a password set
		async checkUserHasPassword() {
			try {
				const payload = { userID: this.userInfo.userID };
				const res = await checkCandidateSignin(payload);
				if (res.status == 200) {
					const hasPass = res.data.data?.hasPassword;
					this.hasPassword =
						hasPass === true || hasPass === undefined ? true : false;
					// If user has no password, open the form immediately
					if (!this.hasPassword) {
						this.savedAuthentication = false;
					}
				}
			} catch (error) {
				console.error("checkUserHasPassword error:", error);
			}
		},
		// Method to fetch profile details
		async getprofileDetails() {
			this.$v.profileDetails.$touch();
			try {
				this.showPersonalDataShimmer = true;

				// Call the API to get profile details
				const res = await getUserDetails();
				if (res.status == 200) {
					this.showVisibilityShimmer = false;
					this.showDeviceActivityShimmer = false;
					this.showPersonalDataShimmer = false;
					this.showBasicAuthShimmer = false;

					this.profileDetails.email = res.data.data.email;
					this.profileDetails.firstName = res.data.data.firstName;
					this.profileDetails.lastName = res.data.data.lastName;
					this.profileDetails.phoneNumber = res.data.data.phoneNumber;
					this.createdAt = res.data.data.createdAt;

					var dateObject = new Date(this.createdAt);
					var day = dateObject.getDate().toString().padStart(2, "0");
					var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
					var year = dateObject.getFullYear();

					this.createdAt = `${day}-${month}-${year}`;
				}
			} catch (error) {
				this.errorModal("Error", "An error occurred"); // Show error toast
				console.error("Error:", error); // Log the error to the console
			}
		},
		reassignDetails() {
			this.profileDetails = this.reassign;
		},

		// Method to update the profile
		async saveProfileDetails() {
			try {
				this.$v.profileDetails.$touch();

				// Check if form fields are not invalid
				if (!this.$v.profileDetails.$invalid) {
					this.profileLoader = true;

					// Call the API to update the profile
					const res = await saveProfileDetails(this.profileDetails);
					if (res.status == 200) {
						this.reassign = this.profileDetails;
						this.successModal(
							"Successfully updated",
							"Profile have been updated"
						);

						this.profileLoader = false;

						this.editProfile = false;
						this.callingRegisterAPI();
					} else {
						this.errorModal("Error", "Something went wrong"); // Show error toast
					}
				} else {
					this.errorModal("Error", "Please fill all the fields"); // Show error toast for incomplete fields
				}
			} catch (error) {
				this.errorModal(
					"Error",
					"An error occurred while updating the profile"
				); // Show error toast
				console.error("Error:", error); // Log the error to the console
			}
		},
		async callingRegisterAPI() {
			const res = await userInfo();
			if (res.status == 200) {
				this.$store.commit("userVUEX/setUserInfo", res.data.data);
			}
		},

		// Method to format a timestamp
		formatTimestamp(timestamp) {
			var dateObject = new Date(timestamp * 1000);

			var day = dateObject.getDate().toString().padStart(2, "0");
			var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
			var year = dateObject.getFullYear();
			var hour = dateObject.getHours().toString().padStart(2, "0");
			var minute = dateObject.getMinutes().toString().padStart(2, "0");
			var period = hour >= 12 ? "PM" : "AM";

			var formattedDate = `${day}-${month}-${year} at ${
				hour % 12 || 12
			}:${minute} ${period}`;

			return formattedDate;
		},

		// Method to sign out of all devices
		async signOutAllDevices() {
			const objectWithCurrentKey = this.device[0].sessions.find((obj) =>
				obj.hasOwnProperty("current")
			);
			console.log(objectWithCurrentKey, "objectWithCurrentKey");
			const payload = {
				email: this.profileDetails.email,
				userid: objectWithCurrentKey,
			};
			this.$socket.emit("signOutAll", payload);
			const res = await signOutAllDevices(); // Call the API to sign out all devices
			if (res.data.status == "Success") {
				this.$store.dispatch("userVUEX/LogOut");
			}
			this.$bvModal.hide("suresignout-2");
		},

		signOutConfirm(j) {
			this.selectedDevice = j;

			this.$bvModal.show("suresignout-2");
		},

		// Method to sign out of a specific device
		async signOut(j) {
			this.loading = true;
			try {
				let payload = {
					id: j.id,
				};
				// const objectWithCurrentKey = this.device[0].sessions.find((obj) =>
				//   obj.hasOwnProperty("current")
				// );
				if (this.currentlyTrue.id === payload.id) {
					console.log("current user");
					await signOutDevices(payload); // Call the API to sign out of the specific device
					this.$socket.emit("signOut", {
						email: this.profileDetails.email,
						userid: payload,
					});
					localStorage.clear();
					this.$store.dispatch("userVUEX/LogOut");
					// this.$router.push(`/login?redirect=${this.$route.fullPath}`);
				} else {
					console.log("not current user");
					const res = await signOutDevices(payload); // Call the API to sign out of the specific device
					if (res.status == 200) {
						this.loading = false;
						this.$bvModal.hide("suresignout-2");
						this.selectedDevice = null;
					}
					this.$socket.emit("signOut", {
						email: this.profileDetails.email,
						userid: payload,
					});

					this.getDeviceActivity(); // Refresh device activity data after sign-out
				}
				this.loading = false;
			} catch (error) {
				this.errorModal("Error", "An error occurred"); // Show error toast
				console.error("Error:", error); // Log the error to the console
				this.loading = false;
			}
		},

		// Method to fetch device activity for the profile
		async getDeviceActivity() {
			this.showDeviceActivityShimmer = true;
			try {
				const response = await getDeviceActivity(this.profileDetails);
				this.device = response.data;
				console.log(this.device, "dev");

				this.device.forEach((deviceItem, index) => {
					const sessions = deviceItem.sessions;
					this.deviceCheck = deviceItem.sessions;
					console.log(this.deviceCheck, "devicecheck");
					const currentIndex = sessions.findIndex(
						(item) => item.current === true
					);

					if (currentIndex !== -1) {
						this.currentlyTrue = sessions[currentIndex];
					}

					sessions.forEach((session) => {
						session.lastAccess = this.formatTimestamp(session.lastAccess);
						session.started = this.formatTimestamp(session.started);
						session.expires = this.formatTimestamp(session.expires);
					});
				});

				this.showDeviceActivityShimmer = false;
			} catch (error) {
				this.errorModal("Error", "An error occurred");
			}
		},
	},
};
</script>

<style scoped>
.defaultCursor {
	cursor: default;
}
.profile-main-container {
	height: calc(100vh - 60px);
	background: #e9ecef;
	color: #72738e;
	top: 60px;
	position: relative;
	padding-left: 60px;
}

.profile-heading {
	border-radius: 5px;
	background: rgba(32, 99, 155, 0.08);
	padding: 10px;
	color: #20639b;
	font-size: var(--size-18);
	font-weight: 600;
	font-family: "Lato", sans-serif;
}

.profile-sub-containers {
	border-radius: 8px;
	border: 1px solid rgba(20, 20, 20, 0.05);
	background: #fff;
	box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.03);
	padding: 25px;
	width: 100%;
}

.profile-height-adjustment {
	height: calc(100% - 112px);
}

.profile-sub-containers-height {
	width: 60%;
	height: 100%;
	overflow: auto;
}

.profile-containers-head {
	color: #000;
	font-size: 16px;
	font-weight: 600;
	font-family: "Montserrat", sans-serif;
}

.profile-inputField {
	border-radius: 8px;
	border: 1px solid var(--gray-300, #d0d5dd);
	background: var(--base-white, #fff);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	color: #333;
	font-size: 14px;
	font-weight: 500;
	padding: 10px 34px 10px 10px;
}

.email-profile-inputField {
	border-radius: 8px;
	border: 1px solid var(--gray-300, #d0d5dd);
	background: var(--base-white, #fff);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	color: #333;
	font-size: 14px;
	font-weight: 500;
	padding: 20px 10px;
}

.email-profile-inputField:disabled {
	background: #ebebeb;
	opacity: 0.65;
	border: unset;
}

.visibility-head {
	color: #3a3c40;
	font-size: 12px;
	font-weight: 600;
	font-family: "Montserrat";
}

.createdOn-jds-font {
	color: #3a3c40;
	font-size: var(--size-13);
	font-weight: var(--weight-LM);
}

.createdOn-jds-subfont {
	color: #3a3c40;
	font-size: var(--size-14);
	font-weight: var(--weight-M);
}

.currentlyActive-tag {
	border-radius: 4px 20px 20px 0px;
	background: #ffb200;
	color: var(--White, #fff);
	font-size: 10px;
	font-weight: 500;
	padding: 4px 7px;
	width: fit-content;
	font-family: "Montserrat", sans-serif;
}

.device-activity-head {
	color: #3a3c40;
	font-size: 14px;
	font-weight: 600;
	font-family: "Montserrat", sans-serif;
}

.sign-out {
	color: var(--bg-proTheme);
	font-size: 13px;
	font-weight: 600;
	font-family: "Montserrat", sans-serif;
}

.started-at {
	color: #7a7a7a;
	font-size: 13px;
	font-weight: 500;
	font-family: "Montserrat";
}
.validation-started-at {
	color: #eb0002;
	font-size: 10px;
	font-weight: 500;
}

.visibility-line {
	border-bottom: 1px solid #8c8c8c;
	padding-bottom: 15px;
	opacity: 0.35;
}

.delDetails-head {
	color: #263238;
	font-size: 14px;
	font-weight: 600;
	font-family: "Montserrat";
}

.required-font {
	color: #eb0002;
	font-size: 14px;
	font-weight: 500;
}

.error-inputField {
	border: 1px solid red;
}

.validation-font {
	color: #eb0002;
	font-size: 10px;
	font-weight: 500;
	position: absolute;
	left: 32%;
}

.basicAuth-validation-font {
	color: #eb0002;
	font-size: 10px;
	font-weight: 500;
	position: absolute;
	left: 2%;
}

.newPass-validation-font {
	color: #eb0002;
	font-size: 10px;
	font-weight: 500;
}

.adjust-uppercase {
	position: absolute;
	top: 38px;
	left: 32%;
}

.select-uppercase-font {
	color: #0f6b00;
	font-size: 10px;
	font-weight: 500;
	font-family: "Montserrat";
}

.reject-uppercase-font {
	color: #8c8c8c;
	font-size: 10px;
	font-weight: 500;
	font-family: "Montserrat";
}

.width-150px {
	width: 150px;
}

.width-7 {
	width: 7%;
}

.width-15 {
	width: 15%;
}

.width-20 {
	width: 20%;
}
.width-25 {
	width: 25%;
}
.width-23 {
	width: 23%;
}

.width-40 {
	width: 40%;
}

.width-48 {
	width: 48%;
}
.width-50 {
	width: 50%;
}
.pwidth-60 {
	width: 60%;
}

.width-70 {
	width: 70%;
}
.width-73 {
	width: 73%;
}
.width-75 {
	width: 75%;
}

.width-80 {
	width: 80%;
}

.width-85 {
	width: 85%;
}

.width-93 {
	width: 93%;
}

@media screen and (max-width: 1745px) {
	.profile-sub-containers-height {
		width: 80%;
	}
}

.disable-modal-subfont {
	color: #344054;
	font-size: 13px;
	font-weight: 500;
}

.disabled-profile-inputField {
	border-radius: 8px;
	border: 1px solid #f6f6f6;
	background: #f6f6f6;
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
	color: #8c8c8c;
	font-size: 14px;
	font-weight: 500;
	padding: 10px 34px 10px 10px;
}

.delete-account-line {
	border-bottom: 1px solid #8c8c8c;
	padding-bottom: 15px;
	margin-left: -7px;
}

.set-noView-icon {
	position: absolute;
	right: 33%;
	top: 8px;
}
.validation-text {
	position: relative;
	left: 10px;
}
.psw-set-noView-icon {
	position: absolute;
	right: 4%;
	top: 4px;
}

.psw-set-noView-icon-2 {
	position: absolute;
	right: 37px;
	top: 5px;
}

.margin-top-class {
	margin-top: 35px;
}

.created-on-font {
	color: #3a3c40;
	font-size: 13px;
	font-weight: 600;
	font-family: "Montserrat", sans-serif;
}

.inputPlaceholder input::placeholder {
	font-weight: 400;
	font-size: 14px;
	color: #667085;
	font-family: "Montserrat", sans-serif;
}

.validation-margin-top {
	margin-top: 47px;
}

.verfify-font-head {
	font-weight: 600;
	font-size: 14px;
	color: #344054;
	font-family: "Montserrat", sans-serif;
}

.verfify-font-subhead {
	font-weight: 500;
	font-size: 12px;
	color: #344054;
	font-family: "Montserrat", sans-serif;
}
.nopadding {
	padding: unset !important;
}

.profile-table-container .profile-header {
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: #696969;
	padding-left: 30px;
}

.profile-table-container .profile-blue-row {
	background-color: #20639b0a;
	border-radius: 10px;
	padding: 14px 0;
	margin: 8px 0;
	display: flex;
	width: 100%;
	padding-left: 30px;
	font-family: "Montserrat", sans-serif;
	font-size: 14px;
	font-weight: 400;
	line-height: 17.07px;
	text-align: left;
	color: #2c2c2c;
}

.profile-table-container .col-2 {
	padding-left: 0px;
	display: flex;
	align-items: center;
}

.profile-table-container .col-3 {
	padding-left: 0px;
	display: flex;
	align-items: center;
}

.profile-table-container .col-1 {
	padding-left: 0px;
	display: flex;
	align-items: center;
}

.profile-table-overflow {
	min-height: auto;
	max-height: 325px;
	overflow: auto;
}

.tim-scroll {
	padding: 15px 20px;
	height: calc(100vh - 500px);
	max-height: 500px;
	overflow: auto;
}
.lightblue-reviews {
	color: #006cde;
}

.lightgreen-interview {
	color: #00c48c;
}
.community {
	color: #904ee2;
}
</style>
